import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalLogComponent, FieldDocumentListOrderItem, FieldDocumentListOrderItemPayload, JobDigitalLogFieldUploadDocumentPayload, JobDigitalLogFormFieldDoc, JobDigitalLogOfflineRange } from '@vitralogy/ng-digital-log';
import { JobDigitalLogForm, JobDigitalLogFormData, JobDigitalLogFormDataHistory, JobDigitalLogFormFieldValue, JobDigitalLogFormTimeSlot, JobDigitalLogFormTimeSlotData } from '@vitralogy/ng-digital-log';
import { JobDigitalLogFormRequestTimeslotSave } from '@vitralogy/ng-digital-log/lib/models/job-digital-log-form-request-timeslot-save.model';
import moment, { Moment } from 'moment';
import { forkJoin, of, Subject } from 'rxjs';
import { fadeIn, fadeOut } from 'src/app/animations';
import { GenericModalComponent } from 'src/app/components/generic-modal/generic-modal.component';
import { NavigationActionButton } from 'src/app/components/navigation-bar/models/navigation-action-button.model';
import { ToastType } from 'src/app/components/toast/models/toast-type.enum';
import { BinderInfo } from 'src/app/models/binder/binder-info.model';
import { JobDigitalLogFormRequest } from 'src/app/models/digital-log/digital-log.model';
import { Job } from 'src/app/models/job.model';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { BinderWizardService } from 'src/app/services/sections/binder/binder-wizard.service';
import { DigitalLogService } from 'src/app/services/sections/job/digital-log.service';
import { OfflineDataType } from 'src/app/services/ui/enums/offline-data-type.enum';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { OfflineStoreData } from 'src/app/services/ui/models/offline-store-data.model';
import { NetworkConnectionService } from 'src/app/services/ui/network-connection.service';
import { OfflineDataStoreService } from 'src/app/services/ui/offline-data-store.service';
import { ToastService } from 'src/app/services/ui/toast.service';
import { some } from 'lodash-es';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';

@Component({
	templateUrl: './digital-log-form.component.html',
	styleUrls: ['./digital-log-form.component.scss'],
	animations: [fadeOut(700), fadeIn(200)]
})
export class DigitalLogFormComponent implements OnInit, OnDestroy {
	@ViewChild('digitalLog', { static: true }) public digitalLog: DigitalLogComponent;
	@ViewChild("offlineDataSavedModal") offlineDataSavedModal: GenericModalComponent;
	@ViewChild("unsavedOfflineDataModal") unsavedOfflineDataModal: GenericModalComponent;
	@ViewChild("fieldDocumentErrorModal") fieldDocumentErrorModal: GenericModalComponent;
	@ViewChild("futureLogDateConfirmationModal") futureLogDateConfirmationModal: GenericModalComponent;
	@ViewChild('addPhotoModal', { static: true }) public addPhotoModal: GenericModalComponent;

	@ViewChild('photoPicker', { static: true }) public photoPicker: ElementRef<HTMLInputElement>;

	public formData: JobDigitalLogFormData[];
	public formLookups: { digitalLogLookupListId: number, values: { id: number, name: string }[] }[];
	public formJsonSchema: JobDigitalLogForm;
	public formTimeSlots: JobDigitalLogFormTimeSlot[];
	public offlineRanges: JobDigitalLogOfflineRange[];
	public fieldDocuments: JobDigitalLogFormFieldDoc[] = [];
	public isFieldDocumentsLoading: boolean = false;
	public currentHistoricalValues = null;
	public jobDetails: Job;
	public externalCloseEventEmitter = new Subject<void>();

	public isNotificationSent = false;

	public binderInfo: BinderInfo = new BinderInfo();

	public customDate: string | Moment;

	public formDataDictionary: Map<string, Map<number, JobDigitalLogFormData>> = new Map<string, Map<number, JobDigitalLogFormData>>();
	public isOnline: boolean = true;
	public unsavedOfflineData: OfflineStoreData = null;
	private latestFieldIdForHistoricalValues = null;
	private redirectToPhotos: boolean = false;
	public targetPhotoGallery: {field: {id: number, name: string, parentFieldName: string | null} | null, groupId: number | null} | null = null;
	
	public readonly moment = moment;
	isSaving: boolean;
	private formData_saved: JobDigitalLogFormData[];
	public fieldPhotoForm: FormGroup;
	public isPhotoSaving: boolean = false;
	public addPhotoMessage: string | null = null;
	private unsubscriber$ = new Subject<void>();

	constructor(
		private activatedRoute: ActivatedRoute,
		private digitalLogService: DigitalLogService,
		private router: Router,
		private cdRef: ChangeDetectorRef,
		private binderService: BinderWizardService,
		private networkConnection: NetworkConnectionService,
		private offlineDataStoreService: OfflineDataStoreService,
		private _sanitizer: DomSanitizer,
	) { }

	public ngOnInit(): void {
		this.formData = this.activatedRoute.snapshot.data.formDetails.formData;
		this.formLookups = this.activatedRoute.snapshot.data.formDetails.lookups;
		this.jobDetails = this.activatedRoute.snapshot.data.jobDetails;
		this.fieldDocuments = this.activatedRoute.snapshot.data.formDetails.fieldDocuments;
		this.formJsonSchema = this.activatedRoute.snapshot.data.formDetails.form;
		this.formTimeSlots = this.formJsonSchema.timeSlots;
		this.offlineRanges = this.formJsonSchema.offlineRanges;


		this.getBinderInfo();

		this.isNotificationSent = !!sessionStorage.getItem('isNotificationSent');

		const queryDate = this.activatedRoute.snapshot.queryParamMap.get('customDate');
		this.customDate = queryDate ? moment(queryDate).startOf('day') : null;
		
		this.fieldPhotoForm = new FormGroup({
			photo: new FormControl(null, [Validators.required]),
			digitalLogFormField: new FormControl(null, [Validators.required]),
			note: new FormControl(null)
		});

		this.networkConnection.isOnline.subscribe((state: boolean) => {
			this.isOnline = state;		
		})
		GlobalSettingsService.priorityNavigationBarActions = new Map<string, NavigationActionButton>();
		GlobalSettingsService.priorityNavigationBarActions.set('close_page', {
			action: () => this.externalCloseEventEmitter.next(),
			icon: 'close',
			listOrder: 1
		});

		GlobalSettingsService.isGlobalLoaderLoading = false;
	}

	ngOnDestroy(): void {
		GlobalSettingsService.priorityNavigationBarActions = null;
		this.networkConnection.unsubscribe();
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public save(data: { staticData: JobDigitalLogFormFieldValue[], timeSlotsData: JobDigitalLogFormTimeSlotData[], ytdReportYear: number, closeAfter: boolean }, isFutureLogDateAllowed: boolean = false): void {

		if (data.staticData.length === 0 && data.timeSlotsData.length === 0 && this.redirectToPhotos) {
			this.redirectToPhotosPage();
			return;
		}
		if (!this.isOnline) {
			this.openOfflineModal();
			return;
		}

		// on save ask for confirmation if any Log date is in the future of the current date
		if (!isFutureLogDateAllowed
			// detect any changes comparing with timeSlotsData_saved
			&& this.checkForTimeSlotDataUpdates(data)
			&& (// existing slots with future date
				(this.formTimeSlots?.length > 0
				 && this.formTimeSlots.some(slot => 
					(slot.overwriteDate 
						? moment(slot.overwriteDate) 
						: moment(slot.originalDate)
					).isAfter(moment().endOf('day'))
					// only include the slots that were part of the submitted data
					&& data.timeSlotsData.some(tsd => tsd.jobDigitalLogFormTimeSlotId === slot.jobDigitalLogFormTimeSlotId)
				))
			 	|| // newly added time slots with future date
				(data.timeSlotsData.some(tsd => 
					!tsd.jobDigitalLogFormTimeSlotId &&
					(tsd.originalDate ? moment(tsd.originalDate) : null)?.isAfter(moment().endOf('day')))
				)
			)
		) {
			this.futureLogDateConfirmationModal.open(data);
			return;
		}

		this.digitalLogService.saveData(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, data.ytdReportYear, data)
			.subscribe(() => {
				forkJoin([
					this.digitalLogService.getData(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId),
					this.digitalLogService.getForm(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId)
				])
					.subscribe(([formData, formJsonSchema]) => {
						this.formJsonSchema = formJsonSchema;
						this.formTimeSlots = this.formJsonSchema.timeSlots;
						this.formData = formData;
						this.formData_saved = formData;
						this.cdRef.detectChanges();
						switch (formJsonSchema.isCompleted) {
							case true:
								if (formJsonSchema?.pendingOnDemandFormAssets.length > 0) {
									this.initData(formJsonSchema, data.closeAfter);
								} else if (this.redirectToPhotos) {
									this.redirectToPhotosPage();
								} else if (data.closeAfter) {
									this.close();
								}
								break;
							case false:
								if (data.closeAfter) {
									this.close();
								} else if (this.redirectToPhotos) {
									this.redirectToPhotosPage();
								}
								break;
							default:
								this.initData(formJsonSchema, data.closeAfter);
								break;
						}
					});
			}, (error) => {
				ToastService.pushToast({
					type: ToastType.Error,
					text: 'Unable to save data!',
					icon: 'error'
				});

				if (error.status === 409 || this.isOnline) {
					console.log('saving data offline...');
					const offlineDataKey = this.offlineDataStoreService.save(OfflineDataType.JobDigitalLogFormResult, this.formJsonSchema.jobDigitalLogFormRequestId, {
						token: TokenHelper.getToken(this.activatedRoute),
						jobDigitalLogFormRequestId: this.formJsonSchema.jobDigitalLogFormRequestId,
						unsavedData: data
					});
					console.log(`offline data saved ... key: ${offlineDataKey}`);
					return;
				}
			});

	}

	private checkForTimeSlotDataUpdates(
		data: {
			staticData: JobDigitalLogFormFieldValue[];
			timeSlotsData: JobDigitalLogFormTimeSlotData[];
			ytdReportYear: number;
			closeAfter: boolean;
		}) {
		return data.timeSlotsData?.some(tsd => {
			if (!tsd.jobDigitalLogFormTimeSlotId) return true; // new slot

			// tsd.jobDigitalLogFormTimeSlotId is not present in saved data
			if (!this.formData_saved?.some(savedData => savedData.jobDigitalLogFormTimeSlotId === tsd.jobDigitalLogFormTimeSlotId)) {
				return true;
			}
			// tsd.jobDigitalLogFormTimeSlotId is present in saved data but values.digitalLogFormFieldId is not present in saved data
			if (!tsd.values.every(v => this.formData_saved?.some(savedData => tsd.jobDigitalLogFormTimeSlotId === savedData.jobDigitalLogFormTimeSlotId
				&& savedData.digitalLogFormFieldId === v.digitalLogFormFieldId))) {
				return true;
			}

			// existing slot - check if there is any change in values
			return !!this.formData_saved?.some(savedData => savedData.jobDigitalLogFormTimeSlotId === tsd.jobDigitalLogFormTimeSlotId
				&& tsd.values.find(v => v.digitalLogFormFieldId === savedData.digitalLogFormFieldId
					&& v.value !== savedData.value
				)
			);
		}
		);
	}

	public initData(formJsonSchema: JobDigitalLogForm, closeAfter: boolean): void {
		if (formJsonSchema.recurrenceFrequencyId === 9 && formJsonSchema.isCompleted && formJsonSchema?.pendingOnDemandFormAssets.length > 0) {
			this.digitalLog.openPendingAssetsConfirmationModal(closeAfter);
		}
	}

	public completePendingOnDemandForms(data: { staticData: JobDigitalLogFormFieldValue[], timeSlotsData: JobDigitalLogFormTimeSlotData[], jobDigitalLogFormRequestIds: JobDigitalLogFormRequestTimeslotSave[], ytdReportYear: number, closeAfter: boolean }): void {
		if (data.staticData.length === 0 && data.timeSlotsData.length === 0 && this.redirectToPhotos) {
			this.redirectToPhotosPage();
			return;
		}
		if (!this.isOnline) {
			this.openOfflineModal();
			return;
		}

		this.digitalLogService.completePendingOnDemandForms(
			TokenHelper.getToken(this.activatedRoute),
			{
				staticData: data.staticData,
				timeSlotsData: data.timeSlotsData,
				jobDigitalLogFormRequestTimeslotIds: data.jobDigitalLogFormRequestIds,
				ytdReportYear: data.ytdReportYear
			}).subscribe(res => {
				forkJoin([
					this.digitalLogService.getData(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId),
					this.digitalLogService.getForm(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId)
				])
					.subscribe(([formData, formJsonSchema]) => {
						if (data.closeAfter) {
							this.close();
						} else if (this.redirectToPhotos) {
							this.redirectToPhotosPage();
						}
						else {
							this.formJsonSchema = formJsonSchema;
							this.formTimeSlots = this.formJsonSchema.timeSlots;
							this.formData = formData;
							this.cdRef.detectChanges();
						}
					});
			}, (error) => {
				ToastService.pushToast({
					type: ToastType.Error,
					text: 'Unable to save data!',
					icon: 'error'
				});

				if (error.status === 409 || this.isOnline) {
					console.log('saving data offline...');
					const offlineDataKey = this.offlineDataStoreService.save(OfflineDataType.JobDigitalLogFormResult, this.formJsonSchema.jobDigitalLogFormRequestId, {
						token: TokenHelper.getToken(this.activatedRoute),
						jobDigitalLogFormRequestId: this.formJsonSchema.jobDigitalLogFormRequestId,
						unsavedData: data
					});
					console.log(`offline data saved ... key: ${offlineDataKey}`);
					return;
				}
			});
	}

	public close(): void {
		if (!!this.customDate) {
			this.router.navigate(
				['../../calendar'],
				{
					relativeTo: this.activatedRoute,
					queryParams: {
						r: this.formJsonSchema.jobDigitalLogFormRequestId,		// r = JobDigitalLogFormRequestId
						y: moment(this.customDate).year()						// y = Year
					}
				}
			);
		} else {
			this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
		}
	}

	public saveTimeSlot(data: JobDigitalLogFormTimeSlot): void {
		this.isSaving = true;
		this.submitDigitalLogTimeSlots([data])
			.subscribe((result: JobDigitalLogFormTimeSlot[]) => {
				this.onTimeSlotsUpdated(result);
				this.isSaving = false;
			});
	}

	private submitDigitalLogTimeSlots(data: JobDigitalLogFormTimeSlot[]) {
		if (data.length === 0) {
			return of([]);
		}

		return this.digitalLogService.saveTimeSlots(
			TokenHelper.getToken(this.activatedRoute),
			this.formJsonSchema.jobDigitalLogFormRequestId,
			this.formJsonSchema.recurrenceFrequencyId !== 9
				? moment(data[0].originalDate).year()
				: (data[0].overwriteDate ? moment(data[0].overwriteDate).year() : moment(data[0].originalDate).year()),
			data
		);
	}

	private onTimeSlotsUpdated(timeSlots: JobDigitalLogFormTimeSlot[]): void {
		const tempTimeSlots = [...this.formTimeSlots];

		timeSlots.forEach(timeSlot => {
			const modifiedSlotIndex = tempTimeSlots.findIndex(item => item.jobDigitalLogFormTimeSlotId === timeSlot.jobDigitalLogFormTimeSlotId);

			if (modifiedSlotIndex >= 0) {
				const initialJobDigitalLogFormExpectationId = tempTimeSlots[modifiedSlotIndex].jobDigitalLogFormExpectationId;
				tempTimeSlots[modifiedSlotIndex] = timeSlot;
				tempTimeSlots[modifiedSlotIndex].initialJobDigitalLogFormExpectationId = initialJobDigitalLogFormExpectationId;
			} else {
				tempTimeSlots.push(timeSlot);
			}
		});

		this.formTimeSlots = tempTimeSlots;
		this.formTimeSlots.forEach(slot => {
			this.digitalLog.stateService.tryUpdateBackupTimeSlotDate(
				moment(slot.originalDate),
				slot.overwriteDate ? moment(slot.overwriteDate) : null
			);
	
			this.digitalLog.stateService.tryUpdateExpectation(slot);
		});
		this.cdRef.detectChanges();
	}
	public getHistoricalValues(jobDigitalLogFormFieldId: number): void {
		this.latestFieldIdForHistoricalValues = jobDigitalLogFormFieldId;
		this.digitalLogService.getDataHistory(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, jobDigitalLogFormFieldId)
			.subscribe(result => this.currentHistoricalValues = result);
	}

	public updateHistoricalValues(state: { create?: JobDigitalLogFormDataHistory[], delete?: JobDigitalLogFormDataHistory[], ytdReportYear: number }): void {
		state.delete?.forEach(item => this.deleteHistoricalValue(item, state.ytdReportYear));
		state.create?.forEach(item => {
			item.value = item.value.toString();	// Should come from package, remove when fixed
			if (!!item.jobDigitalLogFormDataHistoryId) {
				this.updateHistoricalValue(item, state.ytdReportYear);
			} else {
				this.createHistoricalValue(item, state.ytdReportYear);
			}
		});
	}

	public deleteHistoricalValue(value: JobDigitalLogFormDataHistory, ytdReportYear: number): void {
		this.digitalLogService.deleteDataHistory(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, ytdReportYear, value.jobDigitalLogFormDataHistoryId)
			.subscribe(() => this.getHistoricalValues(this.latestFieldIdForHistoricalValues));
	}

	public createHistoricalValue(value: JobDigitalLogFormDataHistory, ytdReportYear: number): void {
		this.digitalLogService.saveDataHistory(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, ytdReportYear, value)
			.subscribe(() => this.getHistoricalValues(this.latestFieldIdForHistoricalValues));
	}

	public updateHistoricalValue(value: JobDigitalLogFormDataHistory, ytdReportYear: number): void {
		this.digitalLogService.updateDataHistory(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, ytdReportYear, value.jobDigitalLogFormDataHistoryId, value.value)
			.subscribe(() => this.getHistoricalValues(this.latestFieldIdForHistoricalValues));
	}

	public disableForm(data): void {
		this.digitalLogService.setFormNotApplicable(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId, data.keepDataUpTo as Date)
			.subscribe(() => {
				this.close();
			});
	}
	public deleteForm(): void {
		this.digitalLogService.deleteOnDemandDLForm(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.jobDigitalLogFormRequestId)
			.subscribe(() => {
				this.close();
			});
	}

	public changeOfflineRanges(state: { save?: JobDigitalLogOfflineRange[], delete?: JobDigitalLogOfflineRange[] }): void {
		state.delete?.forEach(item => this.deleteOfflineRange(item));
		state.save?.forEach(item => {
			if (!!item.jobDigitalLogFormOfflineRangeId) {
				this.updateOfflineRange(item);
			} else {
				this.saveOfflineRange(item);
			}
		});
	}

	private saveOfflineRange(range: JobDigitalLogOfflineRange): void {
		const impactedYears = [...Array(moment(range.endDate).year() - moment(range.startDate).year() + 1)].map((_, index) => moment(range.startDate).year() + index);

		this.digitalLogService.saveOfflineRange(TokenHelper.getToken(this.activatedRoute), range.jobDigitalLogFormRequestId, range, impactedYears)
			.subscribe(rangeId => {
				range.jobDigitalLogFormOfflineRangeId = rangeId;
				this.offlineRanges = [...this.offlineRanges, range];
			});
	}

	private updateOfflineRange(range: JobDigitalLogOfflineRange): void {
		const updatedRangeIndex = this.offlineRanges.findIndex(item => item.jobDigitalLogFormOfflineRangeId === range.jobDigitalLogFormOfflineRangeId);
		const oldRange = this.offlineRanges[updatedRangeIndex];

		const oldRangeYears = [...Array(moment(oldRange.endDate).year() - moment(oldRange.startDate).year() + 1)].map((_, index) => moment(oldRange.startDate).year() + index);
		const newRangeYears = [...Array(moment(range.endDate).year() - moment(range.startDate).year() + 1)].map((_, index) => moment(range.startDate).year() + index);

		const impactedYears = Array.from(new Set<number>([...oldRangeYears, ...newRangeYears]));

		this.digitalLogService.updateOfflineRange(TokenHelper.getToken(this.activatedRoute), range.jobDigitalLogFormRequestId, range, impactedYears)
			.subscribe(() => {
				this.offlineRanges.splice(updatedRangeIndex, 1, range);
				this.offlineRanges = [...this.offlineRanges];
			});
	}

	private deleteOfflineRange(range: JobDigitalLogOfflineRange): void {
		const impactedYears = [...Array(moment(range.endDate).year() - moment(range.startDate).year() + 1)].map((_, index) => moment(range.startDate).year() + index);

		this.digitalLogService.deleteOfflineRange(TokenHelper.getToken(this.activatedRoute), range.jobDigitalLogFormRequestId, range.jobDigitalLogFormOfflineRangeId, impactedYears)
			.subscribe((event) => {
				if (event.type === HttpEventType.Response) {
					const index = this.offlineRanges.findIndex(item => item.jobDigitalLogFormOfflineRangeId === range.jobDigitalLogFormOfflineRangeId);
					this.offlineRanges.splice(index, 1);
					this.offlineRanges = [...this.offlineRanges];
				}
			});
	}

	public getBinderInfo(): void {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		this.binderService.getVirtualBinderInfo(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.digitalLogFormId, this.jobDetails.jobId).subscribe(res => {
			this.binderInfo = res;
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}, error => {
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		});
	}

	public redirectToBinder(): void {
		this.binderService.getVirtualBinderAccessHash(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.digitalLogFormId).subscribe(res => {
			this.router.navigate([res.binderUri]);
		});
	}

	public goToPhotos(target: {field: {id: number, name: string, parentFieldName: string | null} | null, groupId: number | null}): void {
		this.targetPhotoGallery = target;
		if(!!target && !!target.field?.id){
			this.fieldPhotoForm.patchValue({
				digitalLogFormField: target.field.id,
				photo: null,
				note: null
			});				
			this.photoPicker.nativeElement.click();
			return;
		}
		else {
			this.digitalLog.save(false);
			this.redirectToPhotos = true;
		}					
	}

	private redirectToPhotosPage(): void {
		
		this.router.navigate(['photos'], { 
			relativeTo: this.activatedRoute, 
			queryParams: !!this.targetPhotoGallery?.groupId 
				? { groupId: this.targetPhotoGallery.groupId} 
				: {} 
		});
	}

	public notifyBinderManagement(): void {
		this.digitalLogService.notifyBinderManagement(TokenHelper.getToken(this.activatedRoute), this.formJsonSchema.digitalLogFormId).subscribe(res => {

		});
	}

	public openOfflineModal(): void {
		this.offlineDataSavedModal.open();
	}
	public closeOfflineModal(): void {
		this.offlineDataSavedModal.hide();
	}

	public discardOfflineData(): void {
		this.offlineDataStoreService.discardByUniqueStoreKey(OfflineDataType.JobDigitalLogFormResult);
		this.closeOfflineModal();
	}

	public applyOfflineData(): void {
		this.save(this.unsavedOfflineData.data.unsavedData);
		this.unsavedOfflineData = null;
		this.unsavedOfflineDataModal.hide();
	}
	public discardUnsavedOfflineData(): void {
		this.unsavedOfflineData = null;
		this.unsavedOfflineDataModal.hide();
	}

	public uploadFieldDocument(uploadedFieldDocument: JobDigitalLogFieldUploadDocumentPayload): void {
		if (uploadedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId === null) {
			uploadedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId = 0;
		}

		this.isFieldDocumentsLoading = true;
		const data = {
			digitalLogFormFieldId: uploadedFieldDocument.digitalLogFormFieldId,
			documentClassAndTypeMappingId: uploadedFieldDocument.documentClassAndTypeMappingId,
			file: uploadedFieldDocument.file,
			timeSlot: uploadedFieldDocument.jobDigitalLogFormTimeSlot,
			documentContainerId: uploadedFieldDocument.documentContainerId || 0,
			documentLabel: uploadedFieldDocument.documentLabel,
			description: uploadedFieldDocument.description,
			listOrder: uploadedFieldDocument.listOrder,
			isDeprecated: uploadedFieldDocument.isDeprecated
		};

		this.digitalLogService.saveFieldDocument(
			TokenHelper.getToken(this.activatedRoute),
			this.formJsonSchema.jobDigitalLogFormRequestId,
			uploadedFieldDocument.ytdReportYear,
			data
		).subscribe(response => {
			if (!uploadedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId && !!response.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId) {
				this.onTimeSlotsUpdated([response.jobDigitalLogFormTimeSlot]);
			}

			if (uploadedFieldDocument.fieldDocument?.jobDigitalLogFormFieldDocId > 0) {
				this.fieldDocuments = this.fieldDocuments.map(doc => {
					return doc.jobDigitalLogFormFieldDocId === uploadedFieldDocument.fieldDocument.jobDigitalLogFormFieldDocId
						? response.fieldDocument
						: doc;
				});
			}
			else {
				this.fieldDocuments = [
					...this.fieldDocuments,
					response.fieldDocument
				];
			}
			this.isFieldDocumentsLoading = false;
		}, error => {
			this.isFieldDocumentsLoading = false;
			console.error(error);
			this.fieldDocumentErrorModal.open();
			this.fieldDocuments = [...this.fieldDocuments];
		});
	}

	public changeFieldDocumentListOrder(payload: FieldDocumentListOrderItemPayload): void {
		this.isFieldDocumentsLoading = true;
		const docsListOrder = payload.documents.map(doc => ({ jobDocumentId: doc.jobDigitalLogFormFieldDocId, listOrder: doc.listOrder } as FieldDocumentListOrderItem));
		this.digitalLogService.updateFieldDocumentListOrder(
			TokenHelper.getToken(this.activatedRoute),
			this.formJsonSchema.jobDigitalLogFormRequestId,
			payload.ytdReportYear,
			docsListOrder,
			payload.digitalLogFormFieldId
		).subscribe(response => {
			if (response) {
				this.fieldDocuments =  this.fieldDocuments.map(item => {
					return payload.documents.find(obj => obj.jobDigitalLogFormFieldDocId === item.jobDigitalLogFormFieldDocId) || item;
				});
				this.fieldDocuments = this.fieldDocuments.sort((a, b) => a.listOrder - b.listOrder);
			} else {
				this.fieldDocumentErrorModal.open();
			}
		}, error => {
			this.isFieldDocumentsLoading = false;
			console.error(error);
			this.fieldDocumentErrorModal.open();
			this.fieldDocuments = [...this.fieldDocuments];
		}, () => {
			this.isFieldDocumentsLoading = false;
		});
	}

	public editFieldDocument(updatedFieldDocument: JobDigitalLogFieldUploadDocumentPayload): void {
		if (updatedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId === null) {
			updatedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId = 0;
		}

		this.isFieldDocumentsLoading = true;
		const data = {
			digitalLogFormFieldId: updatedFieldDocument.digitalLogFormFieldId,
			documentClassAndTypeMappingId: updatedFieldDocument.documentClassAndTypeMappingId,
			timeSlot: updatedFieldDocument.jobDigitalLogFormTimeSlot,
			documentContainerId: updatedFieldDocument.documentContainerId || 0,
			documentLabel: updatedFieldDocument.documentLabel,
			description: updatedFieldDocument.description,
			listOrder: updatedFieldDocument.listOrder,
			isDeprecated: updatedFieldDocument.isDeprecated,
			documentId: updatedFieldDocument.documentId
		};

		this.digitalLogService.updateFieldDocument(
			TokenHelper.getToken(this.activatedRoute),
			this.formJsonSchema.jobDigitalLogFormRequestId,
			updatedFieldDocument.ytdReportYear,
			data
		).subscribe(response => {
			if (!updatedFieldDocument.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId && !!response.jobDigitalLogFormTimeSlot.jobDigitalLogFormTimeSlotId) {
				this.onTimeSlotsUpdated([response.jobDigitalLogFormTimeSlot]);
			}

			if (updatedFieldDocument.fieldDocument?.jobDigitalLogFormFieldDocId > 0) {
				this.fieldDocuments = this.fieldDocuments.map(doc => {
					return doc.jobDigitalLogFormFieldDocId === updatedFieldDocument.fieldDocument.jobDigitalLogFormFieldDocId
						? response.fieldDocument
						: doc;
				});
			}
			else {
				this.fieldDocuments = [
					...this.fieldDocuments,
					response.fieldDocument
				];
			}
			this.isFieldDocumentsLoading = false;
		}, error => {
			this.isFieldDocumentsLoading = false;
			console.error(error);
			this.fieldDocumentErrorModal.open();
			this.fieldDocuments = [...this.fieldDocuments];
		});
	}

	public removeFieldDocument(data: { jobDigitalLogFormFieldDocId: number, digitalLogFormFieldId: number, ytdReportYear: number, jobDigitalLogFormTimeSlotId: number }): void {
		this.isFieldDocumentsLoading = true;
		this.digitalLogService.deleteFieldDocument(
			TokenHelper.getToken(this.activatedRoute),
			this.formJsonSchema.jobDigitalLogFormRequestId,
			data.ytdReportYear,
			data.digitalLogFormFieldId,
			data.jobDigitalLogFormFieldDocId,
			data.jobDigitalLogFormTimeSlotId
		).subscribe(() => {
			this.fieldDocuments = this.fieldDocuments.filter(doc => doc.jobDigitalLogFormFieldDocId !== data.jobDigitalLogFormFieldDocId);
			this.isFieldDocumentsLoading = false;
		}, error => {
			this.isFieldDocumentsLoading = false;
			console.error(error);
			this.fieldDocumentErrorModal.open();
			this.fieldDocuments = [...this.fieldDocuments];
		});
	}

	public closeFieldDocumentErrorModal(): void {
		this.fieldDocumentErrorModal.hide();
	}

	public closeFutureLogDateConfirmationModal(data): void {
		this.save(data, true);
		this.futureLogDateConfirmationModal.hide();
	}

	public updateLogDateToCurrent(data: any): void {
		if (!this.isOnline) {
			this.openOfflineModal();
			return;
		}

		// overwrite any newly added slots having future date to current date
		var newTimeSlots = data.timeSlotsData.filter(
			tsd => !tsd.jobDigitalLogFormTimeSlotId
				&& (tsd.originalDate ? moment(tsd.originalDate) : null)?.isAfter(moment().endOf('day'))
			);
			// update the overwriteDate of the new time slots to the current date
			newTimeSlots.forEach(slot => {
				slot.overwriteDate = moment().toDate();
				this.digitalLog.stateService.tryUpdateBackupTimeSlotDate(
					moment(slot.originalDate),
					slot.overwriteDate ? moment(slot.overwriteDate) : null
				);
			});

		// update any updated slots having future date to current date
		var updatedTimeSlots = this.formTimeSlots.filter(
			slot => 
				(slot.overwriteDate 
					? moment(slot.overwriteDate) 
					: moment(slot.originalDate)
				).isAfter(moment().endOf('day'))
				// only include the slots that were part of the submitted data
				&& data.timeSlotsData.some(tsd => tsd.jobDigitalLogFormTimeSlotId === slot.jobDigitalLogFormTimeSlotId)
			);
			
		updatedTimeSlots.forEach(slot => {
			slot.overwriteDate = moment().toDate();
		});

		if (updatedTimeSlots.length === 0) {
			this.futureLogDateConfirmationModal.hide();
			this.save(data, true);
			return;
		}

		this.submitDigitalLogTimeSlots(updatedTimeSlots).subscribe(
			(results: JobDigitalLogFormTimeSlot[]) => {
				this.onTimeSlotsUpdated(results);
				this.save(data, true);
			}
		);

		this.futureLogDateConfirmationModal.hide();
	}

	public onPhotoSelected(files: File[]): void {
		let hasFileError = false;
		let fileError = '';
		if (!files?.length) return;

		const filesToUpload = Object.values(files);
		if (some(filesToUpload, { size: 0 })) {
			hasFileError = true;
			fileError = 'The document cannot be empty!';
			return;
		}

		const fileToUpload = filesToUpload[0];
	}

	public onFieldPhotoChanged(files: File[]): void {
		this.addPhotoMessage = null;
		const filesToUpload = Object.values(files);

		//photo size max 10MB 
		const maxAllowedSize = 10 * 1024 * 1024;
		
		const isAnyPhotoExceedMaxSize = filesToUpload.some(file => file.size > maxAllowedSize);

		if (isAnyPhotoExceedMaxSize) {
			this.addPhotoMessage = `Depending on your internet connection speed, you may experience delays due to the file size of the selected files.`;
		} 
		else if (filesToUpload.length > 10 && isAnyPhotoExceedMaxSize) {
			this.addPhotoMessage = `Depending on your internet connection speed, you may experience delays due to the number of files (${filesToUpload.length}) selected and file size.`;
		}

		if (filesToUpload.length > 0) {	
			if(filesToUpload[0].size === 0){
				ToastService.pushToast({
					text: 'The photo cannot be empty!',
					icon: 'error',
					type: ToastType.Error
				});
				this.photoPicker.nativeElement.value = '';
				return;
			}
					
			this.fieldPhotoForm.patchValue({				
				photo: filesToUpload[0],			
			});	
			this.addPhotoModal.open();
		}		
		this.photoPicker.nativeElement.value = '';
	}

	public getPhotoPreviewUrl() {		
		return this.fieldPhotoForm.get('photo').value ? this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.fieldPhotoForm.get('photo').value)) : null;
	}

	public getPhotoPreviewAltName(): string {
		return this.fieldPhotoForm.get('photo')?.value?.name ?? 'Photo Preview';
	}

	public onSavePhoto(): void {
		const formData = this.fieldPhotoForm.getRawValue();
		const requestId = this.formJsonSchema.jobDigitalLogFormRequestId;
		
		const fieldId = formData.digitalLogFormField;
		const note = formData.note;
		const file = formData.photo;

		this.isPhotoSaving = true;

		this.digitalLogService.uploadFormPhotos(TokenHelper.getToken(this.activatedRoute), [file], requestId, true, note, fieldId)
			.pipe(
				takeUntil(this.unsubscriber$)
			)
			.subscribe(
				() => {
					this.addPhotoModal.hide();
					this.fieldPhotoForm.reset();
					//this.digitalLog.refreshPhotosGallery(fieldId);					
					const fields = this.formJsonSchema.fields.map(field => {
						return field.digitalLogFormFieldId === fieldId 
							? {
								...field, 
								photoCount: (field.photoCount ?? 0) + 1
							} : field;
					});
					const globalPhotoCount = (this.formJsonSchema.photosCount ?? 0) + 1
					this.formJsonSchema = { 
						...this.formJsonSchema,
						photosCount: globalPhotoCount,
						fields: [...fields]
					};
					this.cdRef.detectChanges();
					this.isPhotoSaving = false;					
				},
				() => {
					this.isPhotoSaving = false;
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					ToastService.pushToast({
						text: 'Could not add the photo. Please try again!',
						icon: 'error',
						type: ToastType.Error
					});
				}
			);		
	}
}
